import getHelper from '../../../services/getHelper';

export default getHelper('/payment/payment-page-parameters/:id');
